import { Taxation } from '@mews-commander/data-access';
import { composeProps, createPropsExtender } from '@mews/framework';
import { getTaxationsByTaxEnvironmentCode } from '../ducks/taxEnvironments';
import { getEnterpriseTaxEnvironmentCode } from '../ducks/enterprises';
import { useLegacyCommanderSelector, useCurrentEnterprise } from '../enterprise';
import { getCurrentEnterpriseTaxEnvironmentCode } from './session/enterprise';

export const getCurrentEnterpriseTaxations = composeProps(
    getTaxationsByTaxEnvironmentCode,
    createPropsExtender('taxEnvironmentCode', getCurrentEnterpriseTaxEnvironmentCode)
);

export const getEnterpriseTaxations = composeProps(
    getTaxationsByTaxEnvironmentCode,
    createPropsExtender('taxEnvironmentCode', getEnterpriseTaxEnvironmentCode)
);

export const useCurrentEnterpriseTaxations = () => {
    const { taxEnvironmentCode } = useCurrentEnterprise();
    return useLegacyCommanderSelector((state) =>
        getTaxationsByTaxEnvironmentCode(state, { taxEnvironmentCode })
    ) as unknown as Array<Taxation>;
};
